import { merge } from 'lodash';

const InputView = Backbone.View.extend({
  tagName: 'div',
  className: 'form-group',
  events: {
    'blur input.required': 'validate'
  },
  initialize(opts) {
    this.modelKey = opts.modelKey;
    if (this.model) {
      this.listenTo(this.model, 'change', this.updatedModel);
    }
  },
  template(viewModel) {
    return JST[viewModel.template](viewModel);
  },
  render(opts) {
    const html = this.template(opts);
    this.$el.append(html);
    if (_.has(opts, 'hidden') && opts.hidden == true) {
      this.$el.addClass('hidden');
    }

    return this.el;
  },
  renderReadOnly(val) {
    this.$('input').val(val);
  },
  getValue() {
    if (this.$('input').attr('type') === 'submit') {
      return false;
    }
    const name = this.$('input, textarea').attr('name').split('-'),
      val = this.$('input, textarea').val(),
      obj = {};
    name.reduce((prev, curr, i) => {
      let value = (i + 1 === name.length) ? val : {};
      return prev[curr] = value;
    }, obj);
    return obj;
  },
  updatedModel({ labelKey, valueKey }) {
    if (this.modelKey === 'save') {
      return;
    }
    const name = this.modelKey.split('-');
    let val = (name.length > 1 && !_.isNull(this.model.get(name[0]))) ? this.model.get(name[0])[name[1]] : this.model.get(name[0]);
    val = _.isNull(val) ? '' : val;
    this.$('input, textarea').val(val);
  },
  validate() {
    var $this = this.$('input'),
      $valMsg = this.$('span.field-validation-valid'),
      isValid = true;
    if (!$this.hasClass('required')) {
      return true;
    }
    if ($valMsg.html() != '' && ($this.val().length < 1 || $this.val() == 0)) {
      $valMsg.html('');
      $this.removeClass('error');
    }
    if ($this.val().length < 1 || $this.val() == 0) {
      $valMsg.html($this.data('val-required'));
      $this.addClass('error');
      isValid = false;
    } else {
      $valMsg.html('');
      if ($this.hasClass('error')) {
        $this.removeClass('error');
      }
    }
    return isValid;
  }
});

export default InputView;

